import { Icon } from '@/shared-ui/atoms';
import { cn } from '@/lib/utils';
import {
    PAYMENT_METHOD_ICONS,
    PAYMENT_METHOD_LABELS,
    type PaymentMethodId,
} from '@/extensions/snk/lib/payment-method-platforms';

export interface PaymentMethodIconProps {
    method: PaymentMethodId;
    className?: string;
}

export const PaymentMethodIcon = ({ method, className }: PaymentMethodIconProps) => {
    const MethodIcon = PAYMENT_METHOD_ICONS[method];
    const label = PAYMENT_METHOD_LABELS[method];

    return (
        <span data-slot="payment-method-icon" className={cn('inline-flex', className)}>
            <Icon icon={MethodIcon} className="h-10 w-auto" decorative={false} title={label} />
        </span>
    );
};
